import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import MainImage3 from "../assets/HeroImages/MainPot2.jpg";

function Hero() {
  const [bgLoaded, setBgLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = MainImage3;
    img.onload = () => setBgLoaded(true);
  }, []);

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
      <div
        className={`relative min-h-screen md:h-screen transition-opacity duration-1000 ease-in-out ${
          bgLoaded ? "opacity-100" : "opacity-0"
        }`}
        style={{
          backgroundImage: `url(${MainImage3})`,
          backgroundSize: "cover",
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Navbar */}
        <Navbar />

        <header className="relative pt-16 md:pt-0 z-10">
          <div className="mx-auto flex flex-col items-center md:items-start max-w-xl py-12 md:py-16 lg:py-20 gap-8 md:gap-10 px-5 md:ml-10 bg-black/5 backdrop-blur-sm">
            <div className="flex flex-col items-center md:items-start gap-y-5 text-center md:text-left">
              <h1 className="text-3xl font-bold md:text-4xl text-black  max-w-full md:max-w-[500px] leading-tight">
                We craft custom websites and strategic SEO to{" "}
                <span className="bg-[#CFF098] italic text-black">empower growth</span>{" "}
                for women entrepreneurs.
                <span className="hidden">
                  Looking to hire web designers for your project?
                </span>
              </h1>
              <p className="text-1xl font-medium max-w-full md:max-w-[450px] text-black bg-[#CFF098] italic">
                More customers, stronger brand, online success.
              </p>
            </div>
            <div className="flex flex-col items-center md:items-start gap-4 font-regular sm:flex-row">
              <a
                href="/services"
                className="flex rounded-full items-center justify-center sm:justify-start gap-2 bg-[#CFF098] px-4 py-2 text-sm md:px-6 md:py-3 text-black border-[1px] border-black w-full sm:w-auto hover:opacity-60"
              >
                <p className="whitespace-nowrap">EXPLORE OUR SERVICES →</p>
              </a>
            </div>
          </div>
        </header>
      </div>
    </main>
  );
}

export default Hero;
